(function() {
'use strict';

angular
    .module('TR')
    .controller('HotelAvailability', HotelAvailability);

function HotelAvailability(pagingService,
            urlUtils,
            preferences,
            basketStore,
            breadcrumbDetailsService,
            tripService,
            occupancyService,
            scrollService,
            $route,
            $scope,
            arrayUtil,
            $rootScope,
            $location,
            $window,
            hotelSearch,
            reviewService,
            shortlistService,
            cookieService,
            hotel,
            hotelResolver,
            flightSearch,
            authService,
            broker,
            basketService,
            $routeParams,
            $timeout,
            resourceService,
            searchUnitService,
            analytics,
            criteoService,
            currentDestination,
            destinationService,
            currencyService,
            $q,
            $filter,
            bookedEstabId,
            $anchorScroll,
            mandatoryTransferService,
            hotelRoomService) {
    if (hotel == null) { return; }

    this.bookedEstabId = bookedEstabId;

    if ($routeParams.shortlist) {
        shortlistService.addToShortlist(hotel)
            .then(function() {
                authService.bufferRoute(null);  //clear any buffered route that might be left behind
                $location.search('shortlist', null);
            });
        return;
    }

    if (_.get($location.search(), 'source') != null) {
        this.isMeta = true;
    }

    if (_.get($location.search(), 'source') === 'TV') {
        $(window).one('click', () => {
            window.moveTo(0, 0);
            window.resizeTo(screen.availWidth, screen.availHeight);
        });
    }

    scrollTo(0, 0);
    $rootScope.unlockScreen($scope);
    analytics.startTimer(hotel.Title);


    const cm = this;
    const filter = angular.copy(hotelSearch.getFilter());
    let boardTypeFilterSet = hotelSearch.filterSet('BoardTypes');
    let showRoomPredicate = boardTypeFilterSet ? _matchesBoardTypeFilter : _isShortlisted;
    const deferredFlightCost = $q.defer();
    const deferredLowDepositValue = $q.defer();
    const deferredCurrency = $q.defer();
    const deferredFlight = $q.defer();
    const deferredRules = $q.defer();

    cm.priceMode = 1;
    cm.scrollToReviews = scrollToReviews;
    cm.scrollToRooms = scrollToRooms;
    cm.hideRooms = true;
    cm.activeHotel = angular.copy(hotel);
    cm.showMore = false;
    cm.showLessDescription = hotel.Description ? hotel.Description.substr(0, hotel.Description.indexOf('</p>')) : '';
    cm.showLessDescriptionMobile = hotel.Description ? hotel.Description.split(' ').splice(0, 20).join(' ') : '';
    cm.toggleShowMoreLess = toggleShowMoreLess;
    cm.hotel = hotel;
    cm.isMobileDevice = TRPCONFIG.IsMobileDevice;
    cm.isMultiDestHoliday = false;
    cm.isHotelLandingPage = false;
    cm.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
    cm.callToBookEnabled = TRPCONFIG.Domain.CallToBookEnabled;
    cm.showStrikethroughPrice = TRPCONFIG.Domain.EnableStrikethroughPrices;
    cm.longSpecialOfferText = '';

    broker.publish('hotelViewed', cm.hotel);
    cm.facilitiesIcons = hotelSearch.getFacilitiesIcon();

    // Isolate hotel facilites
    cm.hotelFacilities = _.find(cm.hotel.FacilityGroups, fg => {
        return fg.name = 'Facilities';
    });

    /*
     * Setter for cm.hotel.LowDepositValueWithFlight
     */
    function setLowDepositValueWithFlight(promiseFlightCost, promiseLowDepositValue, promiseCurrency, promiseFlight, promiseRules) {
        $q.all([promiseFlightCost, promiseLowDepositValue, promiseCurrency, promiseFlight, promiseRules]).then(data => {
            const roundedCurrencyFilter = $filter('roundedCurrency');
            const unformattedString = $filter('unformattedString');
            const flightCost = data[0];
            const lowDepositeValue = data[1];
            const currency = data[2];
            const flight = data[3];
            const rules = data[4];

            let flightDeposite = 0;
            const flightDepositeAllowed = rules.depositAllowed;

            if (flight != null) {
                flightDeposite = flight.ImmediatePayment.Amount;
            }

            const lowDepositeAndFlightDeposite = flightDeposite + lowDepositeValue;
            const lowDepositeAndFlightCost = flightCost + lowDepositeValue;
            const lowDepositeValueFormated = roundedCurrencyFilter(lowDepositeValue, currency);

            const LOWDEPOSITEHOLIDAY = resourceService.get('LOWDEPOSIT:HOLIDAY');
            const LOWDEPOSITEFLIGHT = resourceService.get('LOWDEPOSIT:FLIGHT');

            const LOWDEPOSITPACKAGEHOLIDAY = resourceService.get('LOWDEPOSITPACKAGEHOLIDAY');

            function getLowDepositeAndFlightCostText() {
                const roundedCost = roundedCurrencyFilter(lowDepositeAndFlightCost, currency);
                return unformattedString(LOWDEPOSITEHOLIDAY, roundedCost, lowDepositeValueFormated);
            }

            function getLowDepositeAndFlightDepositeText() {
                const roundedCost = roundedCurrencyFilter(lowDepositeAndFlightDeposite, currency);
                return unformattedString((cm.packagePrice ? LOWDEPOSITPACKAGEHOLIDAY : LOWDEPOSITEFLIGHT), roundedCost, lowDepositeValueFormated);
            }

            cm.hotel.lowDepositText = flightDepositeAllowed ?
                getLowDepositeAndFlightDepositeText() :
                getLowDepositeAndFlightCostText();
        });
    }

    setLowDepositValueWithFlight(deferredFlightCost.promise, deferredLowDepositValue.promise, deferredCurrency.promise, deferredFlight.promise, deferredRules.promise);

    cm.loadingReviews = false;
    cm.loadingFirstReviews = false;
    cm.setTab = setTab;
    cm.mapTab = mapTab;
    cm.reviewsTab = reviewsTab;
    cm.photosTab = photosTab;
    cm.search = search;
    cm.selectRooms = selectRooms;
    cm.showAllRooms = false;
    cm.tab = 'detail';
    cm.tabClass = tabClass;
    cm.toggleShortlist = toggleShortlist;
    cm.roomsLeftLimit = TRPCONFIG.Domain.UrgencyMessageRoomThreshold;
    cm.roomAvailability = getRoomAvailability;
    cm.changeHotel = changeHotel;
    cm.isHoliday = $route.current && $route.current.area === 'holidays';
    const pi = $location.search().pi;
    cm.paging = pagingService.data(pi == null ? 1 : parseInt(pi) + 1, 10, cm.hotel.CustomerReviewCount);
    cm.pageReviews = TRPCONFIG.Domain.ReviewsEnabled ? _getReviews : null;

    cm.showSearchUnit = _showSearchUnit();
    cm.toggleSearchUnit = toggleSearchUnit;
    cm.topHotelRoomHasSpecialOffer = topHotelRoomHasSpecialOffer;
    cm.getTopHotelRoomSpecialOffer = getTopHotelRoomSpecialOffer;
    cm.showAtol = hotelSearch.showAtol();
    cm.showMobileSearch = TRPCONFIG.DeviceCategory === 'Phone';

    tripService.usePackageRates().then(packagePrice => cm.packagePrice = packagePrice);

    tripService.getDurationSummary(searchUnitService.hotel, $routeParams.tripId).then(ds => {
        cm.durationSummary = ds;
        cm.searchSummary = ds ? `${ds}, ${hotelSearch.getOccupancySummary()}` : '';
        // This is a hack to ensure that the number of nights are updated.
        setTimeout(function() {
            cm.durationSummary = ds;
            cm.searchSummary = ds ? `${ds}, ${hotelSearch.getOccupancySummary()}` : '';
        }, 100);
    });

    let timer = 0;
    TRPCONFIG.Domain.DefaultHotelDates ? timer = 0 : timer = 200;
    // This is a hack to ensure that the number of nights are updated from the updated trip.
    setTimeout(() => {
        tripService.getHotelsRequestNumberOfNights($routeParams.tripId).then(numNights => cm.numNights = numNights);
        tripService.getHotelsRequestCheckInDate($routeParams.tripId).then(checkInDate => cm.hotelCheckInDate = checkInDate);
        tripService.getHotelsRequestCheckOutDate($routeParams.tripId).then(checkOutDate => cm.hotelCheckOutDate = checkOutDate);
    }, timer);

    currentDestination.getCurrentDestination().then(dest => cm.destination = dest);

    broker.subscribe('HotelAvailability', 'boardTypeFilterUpdated', function(ev) {
        boardTypeFilterSet = ev.data != null && ev.data.length > 0;
        showRoomPredicate = boardTypeFilterSet ? _matchesBoardTypeFilter : _isShortlisted;
        filter.BoardTypes = ev.data;
        _setRooms();
    });

    broker.subscribe('HotelAvailability', 'hotelDetailCallFailed', function(ev) {
        cm.showSpinner = null;
        analytics.track('mixpanel', 'SupplierDetailError', {
            estabId: ev.data.EstabId
        });

        //When the hotel details call fails for any reason, we are assuming that the room is sold out
        cm.hotelDetailsFailed = true;
        _.forEach(cm.hotel.Rooms[0].Availability, room => {
            if (room.Id === ev.data.RoomAndBoardIds[0]) {
                room.soldOut = true;
            }
        });
        broker.publish('roomsSet', cm.hotel);

        $rootScope.unlockScreen($scope);
        $timeout(() => scrollService.scrollTo('#roomsPanel'), 100);
    });

    broker.subscribe('HotelAvailability', 'continueToBookFromFlightDetailsModal', function(e) {
        continueToBook(e.data.priceId);
    });

    if (TRPCONFIG.Domain.ShortlistsEnabled) {
        shortlistService.isHotelShortlisted(cm.hotel).then(function(inList) {
            cm.hotelInShortlist = inList;
        });
    }

    $scope.$watch('cm.tab', function() {
        $rootScope.$emit('hideCloseButton');
    });

    angular.forEach(['detail'], function(val) {
        cm[`${val}Tab`] = function() {
            cm.setTab(val);
        };
    });

    //call the hotel resolver again and this time make sure we ask for the rooms as well
    $timeout(() => scrollService.scrollTo(scrollService.getScrollTarget()), 500);
    // Below Timeout to ensure the delay to update trip and receive trip with updated AvaiabilitySearchId for Nights Allocation.
    $timeout(() => {
            const includeRooms = true;
            hotelResolver.resolve(includeRooms)
                .then(h => {
                    broker.publish('hotelCacheReady', h);
                    if (h.LowDepositValue) {
                        deferredLowDepositValue.resolve(h.LowDepositValue);
                    }
                    // Update hotel with all dest params
                    destinationService.getDetails(h)
                        .then(dest => cm.hotelDestination = dest)
                        .then(() => {
                            cm.hotel = h;
                            _setRooms();
                            cm.hideRooms = false;
                        });
                });
        }, timer);

    const locSearch = $location.search();
    switch (locSearch.pd) {
        case 'mp':
            $timeout(function() { cm.mapTab(); });
            break;
        case 'rv':
            cm.reviewsTab();
            if (locSearch.lr) {
                reviewService.likeReview.organic(locSearch.lr, true);
            }
            break;
        case 'ph':
            cm.photosTab();
            break;
    }

    if (TRPCONFIG.DeviceSettings.AutoLoadReviews && locSearch.pd !== 'rv' && TRPCONFIG.Domain.ReviewsEnabled) {
        reviewsTab();
    }

    broker.subscribe('HotelAvailability', 'roomSearchStarted', function hideRooms() {
        cm.hideRooms = true;
    });

    broker.subscribe('HotelAvailability', 'roomSearchEnded', function hideRooms() {
        cm.hideRooms = false;

        cm.hotel.Rooms = arrayUtil.map(cm.hotel.Rooms, function(r) {
            r.selected = r.Availability[0].Id;
            return r;
        });
        tripService.getHotelsRequestNumberOfNights($routeParams.tripId).then(numNights => cm.numNights = numNights);
        scrollService.scrollTo('#roomsPanel');
        _setRooms();
    });

    broker.subscribe('HotelAvailability', 'boardRoomUpdate', function(e) {
        const roomInfo = e.data;
        const index = Number(roomInfo.id.slice(2));
        let occ = cm.hotel.Rooms[index].Title;
        occ = occ.slice(occ.indexOf('(') + 1, occ.indexOf(')'));
        const roomAndBoardUpdated = `${roomInfo.roomDescription}, ${roomInfo.boardDescription}, ${occ}`;
        cm.roomAndBoardsData[index] = roomAndBoardUpdated;
    });

    cm.isHotelFirstJourney = basketService.isFlightPreselected();

    function _setRooms() {
        sessionStorage.removeItem('IncludedExtras');
        sessionStorage.removeItem('Transfer');
        getCancellationCharges();
        cm.allRoomsAvailable = true;
        cm.currencyCode = searchUnitService.getCurrency();
        if (cm.hotel.Rooms != null && cm.hotel.Rooms.length > 0) {
            cm.hotel.Rooms = arrayUtil.map(cm.hotel.Rooms, function(r, i) {
                if (boardTypeFilterSet) {
                    r.FilteredAvailability = arrayUtil.filter(r.Availability, _matchesBoardTypeFilter);
                    if (r.FilteredAvailability.length > 0) {
                        r.selected = r.FilteredAvailability[0].Id;   //overwrite the preselected room becuase it may have been filtered out
                    } else {
                        cm.allRoomsAvailable = false;
                    }
                } else {
                    r.FilteredAvailability = r.Availability;
                }

                r.isRoomKidsFree = occupancyService.isRoomKidsFree(i) && cm.isKidsFree;
                r.nonInfants = r.isRoomKidsFree
                    ? occupancyService.getOnlyAdultsPerRoom(i)
                    : occupancyService.getNumberOfNonInfantsForRoom(i);
                return r;
            });
            cm.lowestPriceRoomDescription = cm.hotel.Rooms[0].Availability[0].RoomDescription;
            cm.nonInfants = occupancyService.getNumberOfNonInfantPassengers();
            cm.roomAndBoardsData = [];
            for (let i = 0; i < cm.hotel.Rooms.length; i++) {
                let occ = cm.hotel.Rooms[i].Title;
                occ = occ.slice(occ.indexOf('(') + 1, occ.indexOf(')'));
                cm.singleRoomOccupancy = cm.hotel.Rooms.length === 1 ? occ : '';
                cm.roomAndBoardsData.push(`${cm.hotel.Rooms[i].Availability[0].RoomDescription}, ${cm.hotel.Rooms[i].Availability[0].BoardDescription} (${occ})`);
            }
            const currentFbt = $location.search() && $location.search().fbt;
            if (currentFbt || boardTypeFilterSet) {
                const multipleBoardTypes = currentFbt ? [...currentFbt] : filter.BoardTypes.toString();
                cm.lowestPriceBoardType = findLowestBoardDescLabel(cm.hotel.Rooms[0].Availability, multipleBoardTypes, 1);
            } else {
                cm.lowestPriceBoardType = lowestPriceBoardType(cm.hotel.Rooms[0].Availability, 1);
            }

            $timeout(() => broker.publish('roomsSet', cm.hotel));
        }

        //find out how many other hotels the user can look through if we dont have any availability for the current hotel
        if ((cm.hotel.Rooms == null || cm.hotel.Rooms.length === 0) && $routeParams.tripId) {
            tripService.getTrip($routeParams.tripId).then(trip => {
                hotelSearch.getSearchResults(trip.HotelsRequest.AvailabilitySearchId, { ignoreTracking: true }).then(data => {
                    cm.HotelCount = data.Aggregates.HotelCount;
                    cm.LowestPricedHotel = data.Aggregates.LowestPricedHotel;
                    cm.nonInfants = occupancyService.getNumberOfNonInfantPassengers();
                    analytics.trackEvent({ category: 'hotelResultsPage', action: 'noRates', label: 'no hotel availability message' });
                });
            });
        }

        //this calculates the total number of room availability for all rooms
        const totalRooms = cm.hotel.Rooms ? (arrayUtil.reduce(arrayUtil.sum, arrayUtil.map(cm.hotel.Rooms, function(rr) { return rr.FilteredAvailability.length; }))) : 0;
        const defaultMax = cm.hotel.Rooms ? 5 * cm.hotel.Rooms.length : 5;

        //this calculates the number of rooms that should be shown according to the showRoomPredicate
        let maxRooms = cm.hotel.Rooms ? (arrayUtil.reduce(arrayUtil.sum, arrayUtil.map(cm.hotel.Rooms, function(rr) {
            return arrayUtil.filter(rr.FilteredAvailability, showRoomPredicate).length;
        }))) : 0;

        if (maxRooms > defaultMax) {
            maxRooms = defaultMax;
        }

        cm.moreRooms = cm.hotel.Rooms ? (totalRooms - maxRooms) : 0;

        if (cm.hotel.Rooms) {
            cm.roomLimit = function(r) {
                return cm.showAllRooms || showRoomPredicate(r);
            };

            cm.toggleExtraRooms = function() {
                if (cm.showAllRooms) {
                    scrollService.scrollTo('#roomsPanel', { animate: true }).then(function() {
                        cm.showAllRooms = !cm.showAllRooms;
                    });
                } else {
                    cm.showAllRooms = !cm.showAllRooms;
                }
            };

            cm.longSpecialOfferText = getTopLongSpecialOfferText();
            if (TRPCONFIG.Domain.EnableStrikethroughPrices && cm.hotel.Rooms.length === 1) {
                cm.promoPriceSavingText = getPromoPriceSavingText();
            }
            updateRibbons(cm.hotel);
        }

        if (cm.hotel.IsCityTaxIncludedInPrice) {
            cm.cityTax = {};
            if (cm.hotel.Rooms != null && cm.hotel.Rooms.length > 0
                && cm.hotel.Rooms[0].Availability && cm.hotel.Rooms[0].Availability.length > 0) {
                let totalTax = 0;
                let totalLocalTax = 0;
                cm.hotel.Rooms.forEach(room => {
                    totalTax += room.Availability[0].CityTax;
                    totalLocalTax += room.Availability[0].CityTaxLocalAmount;
                });
                cm.cityTax.TotalAmount = totalTax;
                cm.cityTax.CityTaxLocalAmount = Math.ceil(totalLocalTax);
                cm.cityTax.CurrencyCode = cm.hotel.Rooms[0].Availability[0].CityTaxLocalCurrency;
            }
        }

        cm.mandatoryExtras = hotelSearch.getMandatoryExtra(cm.hotel);
        cm.MaldivesIsMandatory = hotelSearch.getMaldivesIsMandatory(cm.hotel);
        cm.mandatoryTransfer = cm.hotel.RequestedRooms && cm.hotel.RequestedRooms[0].Availability &&
        cm.hotel.RequestedRooms[0].Availability[0].BoardOptions &&
        cm.hotel.RequestedRooms[0].Availability[0].BoardOptions[0].IncludedExtras ?
        cm.hotel.RequestedRooms[0].Availability[0].BoardOptions[0].IncludedExtras[0].Title : '';
        if (cm.MaldivesIsMandatory && cm.mandatoryExtras) {
            sessionStorage.setItem('IncludedExtras', JSON.stringify(cm.hotel.RequestedRooms[0].Availability[0].BoardOptions[0].IncludedExtras[0]));
        }
        $timeout(function() {
            scrollService.scrollTo(scrollService.getScrollTarget());
        }, 500);

        analytics.endTimer(cm.hotel.Title);
    }

    function getCancellationCharges() {
        cm.cancellationData = {};
        let AvailabilitySearchId = null;

        let count = 0;
        let intvl = setInterval(function() {
            count++;
            if (sessionStorage.getItem('hotelData') && sessionStorage.getItem('FlightDetailsId')) {
                clearInterval(intvl);
                let hotel = JSON.parse(sessionStorage.getItem('hotelData') || '{}');
                let flightId = sessionStorage.getItem('FlightDetailsId');
                tripService.getTrip($routeParams.tripId)
                    .then(trip => {
                        if (trip.HotelsRequest) {
                            AvailabilitySearchId = trip.HotelsRequest.AvailabilitySearchId;
                            if (hotel.Id && flightId && AvailabilitySearchId) {

                                if (sessionStorage.getItem('BrandedFareDetailsSessionId')) {
                                    flightId = sessionStorage.getItem('BrandedFareDetailsSessionId');
                                }

                                const req =
                                {
                                    FlightDetailsId: flightId,
                                    HotelAvailabilitySearchId: AvailabilitySearchId,
                                    EstabId: hotel.Id,
                                    DomainId: TRPCONFIG.Domain.DomainId,
                                    CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                                    CultureCode: TRPCONFIG.Domain.CultureCode,
                                    TripId: $routeParams.tripId
                                };
                                return hotelRoomService.getCancellationChargesService(req);
                            }
                        }
                    });
            } else if (!sessionStorage.getItem('hotelData') && !sessionStorage.getItem('FlightDetailsId') && count === 50) {
                clearInterval(intvl);
                console.error('hotelData not found');
            }
        }, 100);
    }

    function _getReviews(page, e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        cm.loadingReviews = true;
        if (page === 1) {
            cm.loadingFirstReviews = true;
        }
        reviewService.getReviews(cm.hotel, page - 1).then(function(result) {
            cm.reviews = result.reviews;
            cm.loadingReviews = false;
            cm.loadingFirstReviews = false;
            cm.paging = pagingService.data(page, 10, cm.hotel.CustomerReviewCount);
        });
    }

    function _matchesBoardTypeFilter(b) {
        return arrayUtil.indexOf(filter.BoardTypes, function(bt) {
                return parseInt(bt) === b.BoardType;
        }) >= 0;
    }

    function _isShortlisted(b) {
        return b.IsShortlisted;
    }

    function getRoomAvailability() {
        if (cm.hotel.Rooms.length === 1) {
            return cm.hotel.Rooms[0].Availability.length;
        }

        if (cm.hotel.Rooms.length > 1) {
            let roomOptions = 0;

            angular.forEach(cm.hotel.Rooms, function(room) {
                roomOptions += room.Availability.length;
            });

            return roomOptions;
        }
    }

    function _showSearchUnit() {
        let showSearchUnit;
        if (TRPCONFIG.Domain.SearchUnitExpandedForMeta && cm.isMeta) {
            showSearchUnit = (TRPCONFIG.Domain.SearchUnitExpanded && TRPCONFIG.DeviceCategory !== 'Phone') || cm.isMeta;
        } else {
            showSearchUnit = TRPCONFIG.Domain.SearchUnitExpanded && TRPCONFIG.DeviceCategory !== 'Phone';
        }
        return showSearchUnit;
    }

    function toggleShortlist() {
        shortlistService.toggleHotel(cm.hotel).then(function(inShortlist) {
            cm.hotelInShortlist = inShortlist;
        });
    }

    function tabClass(tab) {
        if (tab instanceof Array) {
            return tab.indexOf(cm.tab) >= 0 ? 'active' : '';
        }
        return tab === cm.tab ? 'active' : '';
    }

    function scrollToRooms() {
        scrollService.scrollTo('#roomsPanel', { animate: true });
        analytics.trackEvent({ label: 'scroll to rooms grid' });
    }

    function scrollToReviews() {
        reviewsTab();
        scrollService.scrollTo('#reviewsSection', { animate: true });
    }

    function toggleShowMoreLess() {
        cm.showMore = !cm.showMore;
    }

    function setTab(tab) {
        if (cm.tab !== tab) {
            cm.tab = tab;
        }
    }

    function reviewsTab() {
        cm.setTab('reviews');
        cm.reviews = [];
        _getReviews(cm.paging.page);
    }

    function photosTab() {
        cm.setTab('photos');
    }

    function mapTab() {
        cm.setTab('map');
        $scope.$broadcast('mapTabSelected');
    }

    function _chosenRooms() {
        return arrayUtil.map(arrayUtil.filter(cm.hotel.Rooms, function(rr) { return rr.selected != null; }), function(rr) {
            return rr.selected;
        });
    }

    function selectRooms(roomIds, room) {
        if (!roomIds) {
            roomIds = _chosenRooms();
        }

        if (TRPCONFIG.Domain.MandatoryExtrasEnabled && !cm.isHoliday && (roomIds.length > 1 || room)) {
            checkOnMandatoryTransfers(roomIds);
        } else {
            continueToBook(roomIds);
        }
    }

    function continueToBook(roomIds) {
        const { tripId } = $routeParams;

        cookieService.set('VoucherCode', '');
        cookieService.set('VoucherWarnMessage', '');
        cookieService.set('SelectedPrices', roomIds || '');

        try {
            analytics.track('Event', 'SelectHotelRoom', {
                Revenue: cm.hotel.MinCost,
                HotelTitle: cm.hotel.Title
            });
        } catch (err) {}

        if (roomIds == null) {
            roomIds = _chosenRooms();
        }
        cm.showSpinner = roomIds[0];
        $rootScope.lockScreen($scope, {
            title: resourceService.get('PREPARINGBOOKING'),
            loadingScreenStyle: 'booking-hotelAvailabilityCtrl'
        });
        analytics.track('mixpanel', 'HotelDetailClick', {
            AwardClicked: !!_.get(hotel, 'AwardDetails')
        });

        if (cm.isMultiDestHoliday) {
            return tripService.getTrip(tripId)
                .then(() => basketService.selectHotelRooms(cm.hotel, roomIds, tripId))
                .then(() => tripService.changeTripType(tripId, tripService.tripTypes.Holiday));
        }
        return basketService.selectHotelRooms(cm.hotel, roomIds, tripId);
    }

    function checkOnMandatoryTransfers(roomIds) {
        if (!roomIds) {
            roomIds = _chosenRooms();
        }

        const roomGridData = hotelRoomService.restructureData(cm.hotel);
        let selectedPrices = {};
        for (let i = 0; i < roomIds.length; i++) {
            selectedPrices[`id${i}`] = roomIds[i];
        }
        const rooms = mandatoryTransferService.getRoomsWithTransfers(cm.hotel, roomGridData, selectedPrices);
        if (rooms.length > 0) {
            const priceMode = cm.priceMode;
            broker.publish('showModalAddFlightDetailsForMultiRooms', { rooms, priceMode });
        } else {
            continueToBook(roomIds);
        }
    }

    function search() {
        basketService.startWorkflow(basketService.hotelBooking).then(null, function(errors) {
            $scope.$emit('flash:error', errors);
        });
    }

    function changeHotel() {
        if (cm.isMultiDestHoliday) {
            $location.url(`/holidays/january-sale/${$routeParams.tripId}`);
            return;
        }
        if ($routeParams.tripId && $route.current.area) {
            if (cm.dealsMode) {
                tripService.getTrip($routeParams.tripId).then(trip => {
                    if (trip && trip.Deal) {
                        $location.url(urlUtils.stripLeadingSlash(trip.Deal.OriginPath));
                    }
                });
            } else {
                tripService.setDirectToHotel($routeParams.tripId, false).then(function() {
                    let nextUrl = $routeParams.BookingRef ?
                        `dashboard/amend-booking/${$routeParams.BookingRef}/${$routeParams.BookingId}/${$routeParams.tripId}` :
                        `${$route.current.area}/${$route.current.area === 'holidays' ? 'hotels/' : ''}${$routeParams.tripId}`;
                    $location.path(nextUrl);
                });
            }
        }
    }

    function toggleSearchUnit() {
        cm.showSearchUnit = !cm.showSearchUnit;
        if (cm.showSearchUnit) {
            hotelSearch.toggleSearch('[ng-show="cm.showSearchUnit"]');
            let el = document.querySelectorAll('.ekh-search-panel')[0];
            el.classList.remove('panel-hide');
        }
}

    function getTopHotelRoomSpecialOffer() {
        return {
            offerText: _.get(cm, 'hotel.Rooms[0].Availability[0].LongSpecialOfferText', ''),
            roomType: _.get(cm, 'hotel.Rooms[0].Availability[0].RoomDescription', '')
        };
    }

    function topHotelRoomHasSpecialOffer() {
        return _.get(cm, 'hotel.Rooms[0].Availability[0].LongSpecialOfferText', '').trim() !== '';
    }

    function getTopLongSpecialOfferText() {
        const rooms = cm.hotel.Rooms[0] || [];
        let text = '';

        _.forEach(rooms.Availability, availability => {
            if (availability.LongSpecialOfferText) {
                text = availability.LongSpecialOfferText;
                return false;
            }
        });

        return text;
    }

    function getPromoPriceSavingText() {
        const room = cm.hotel.Rooms[0].Availability[0] ? cm.hotel.Rooms[0].Availability[0] : null;
        const roomPrice = cm.hotel.Rooms[0].Availability[0] ? cm.hotel.Rooms[0].Availability[0].Cost : null;
        if (room && roomPrice && room.Promotions && room.Promotions.length > 0) {
            const appliedPromo = room.Promotions.filter(function(promo) {
                                        return promo.Prices ? promo.Prices.Price === roomPrice && promo.ShowWasNowPrice : false;
                                    });
            return appliedPromo.length > 0 && appliedPromo[0].Prices.WasPrice > appliedPromo[0].Prices.Price ? (appliedPromo[0].Prices.WasPrice - appliedPromo[0].Prices.Price) : null;
        }
    }

    function lowestPriceBoardType(arr) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].IsCheapest) {
                return arr[i].BoardDescription;
            }
        }
    }

    function findLowestBoardDescLabel(arr, fbt) {
        if ((!fbt || fbt.length === 0) && (!arr || arr.length === 0)) { return; }
        const filtered = arr.filter(room => {
            return fbt.indexOf(room.BoardType) !== -1;
        });
        const [cheapestPrice] = sortBoardTypes(filtered);
        return cheapestPrice && cheapestPrice.BoardDescription;
    }

    function sortBoardTypes(arr) {
        return arr.sort((a, b) => a.Cost >= b.Cost ? 1 : -1);
    }

    function makeRibbonStyles(overlay) {
        const pillPrefix = 'sc-c-pill';
        const textPrefix = 'u-text';
        const pillStyle = [pillPrefix, `${pillPrefix}--${overlay.ColourClass}`];
        const promoTextStyle = [`${textPrefix}--${overlay.ColourClass}`];
        overlay.EffectClasses.forEach(effect => {
            pillStyle.push(`${pillPrefix}--${effect}`);
            promoTextStyle.push(`${textPrefix}--${effect}`);
        });

        return {
            pillClass: pillStyle.join(' '),
            promoTextClass: promoTextStyle.join(' ')
        };
    }

    function updateRibbons(hotel) {
        hotel.Rooms.forEach(room => {
            room.Availability.forEach(item => {
                if (item.OverlayNew) {
                    const appliedToAllRooms = room.Availability.every(board => {
                        return (hotel.PromotionRibbon && hotel.PromotionRibbon.Text) === (board.OverlayNew && board.OverlayNew.Text);
                    });
                    if (!appliedToAllRooms) {
                        const styles = makeRibbonStyles(item.OverlayNew);
                        const textSeparator = getSeparator(item.OverlayNew.Text);

                        item.pillClass = styles.pillClass;
                        item.promoTextClass = styles.promoTextClass;
                        item.promotionText = item.OverlayNew.Text.toUpperCase()
                                                                            .split(textSeparator)
                                                                            .map(textLengthValidator);
                    }
                }
            });
        });
    }

    function getSeparator(ribbonText) {
        return ribbonText && ribbonText.includes('|') ? '|' : ' ';
    }

    function textLengthValidator(text) {
        return text && text.slice(0, 10);
    }

    if ($routeParams.tripId) {
        tripService.getCurrency($routeParams.tripId).then(cur => {
            deferredCurrency.resolve(cur);
            cm.currencyCode = cur;
        });
        tripService.getTrip($routeParams.tripId).then(function(trip) {
            criteoService.enqueue(cm.hotel, 'hotel', trip.TripType);
            analytics.track('mixpanel', 'HotelPage');
            analytics.track('Facebook', 'HotelPage');

            cm.hotelAvailabilitySearchId = _.get(trip, 'HotelsRequest.AvailabilitySearchId');
            cm.isMultiDestHoliday = trip.TripType === tripService.tripTypes.MultiDestHoliday;
            cm.isKidsFree = trip.IsKidsFree &&
                (parseInt(cookieService.get('KidsPromoAB')) === 1 || TRPCONFIG.Domain.isAgentMode);

            if (cm.isKidsFree) {
                cm.payingIndividuals = occupancyService.getOnlyPayingIndividuals();
            }

            const numPassengers = occupancyService.getNumberOfNonInfantPassengers() || 1;
            basketStore.rules(trip.BasketId).then(data => {
                cm.depositAllowed = data.depositAllowed;
                deferredRules.resolve(data);
            });
            basketStore.flight(trip.BasketId).then(data => { //TODO Rewrite for flightCost
                cm.flight = data;
                deferredFlight.resolve(data);
            });
            basketStore.flightCost(trip.BasketId).then(c => {
                deferredFlightCost.resolve(c);
                cm.totalFlightCost = c;
                cm.flightCostPerPerson = c / numPassengers;
                cm.marhabaCost = 0;

                if (cm.packagePrice && TRPCONFIG.Domain.MarhabaEnabled) {
                    basketStore.marhabaCost(trip.BasketId).then(cost => {
                        cm.marhabaCost = cost || 0;
                        sessionStorage.setItem('marhabaCost', cost);
                        return cost;
                    });
                }

                //make sure we don't set this up until the flight costs are available
                cm.holidayPriceByMode = function(hotelPrice, roomNonInfants, marhabaCost = 0, priceMode) {
                    const payingNum = cm.isKidsFree ? cm.payingIndividuals : roomNonInfants;
                    let price;
                    if (priceMode === 0) {
                        price = hotelPrice / payingNum + cm.flightCostPerPerson + (marhabaCost / payingNum);
                    }
                    if (priceMode === 1) {
                        price = hotelPrice + (marhabaCost + cm.totalFlightCost * (roomNonInfants / cm.nonInfants));
                        TRPCONFIG.Domain.RoomSummaryFare = price;
                    }

                    if (price && price !== 'NaN') {
                        return price;
                    }
                };

                cm.holidayPriceAllMode = function(hotelPrice, roomNonInfants, marhabaCost = 0, pm) {
                    const payingNum = cm.isKidsFree ? cm.payingIndividuals : roomNonInfants;
                    if (pm === 0) {
                        return hotelPrice / payingNum + cm.flightCostPerPerson + (marhabaCost / payingNum);
                    }
                    if (pm === 1) {
                        return hotelPrice + (marhabaCost + cm.totalFlightCost * (roomNonInfants / cm.nonInfants));
                    }
                };

                cm.getHolidayDetail = function(type) {
                    if (sessionStorage.getItem('hotelSearchResults')) {
                        const searchHotelData = JSON.parse(sessionStorage.getItem('hotelSearchResults'));
                        const hotelSelected = searchHotelData.filter(function(hData) {
                            return hData.Id === cm.hotel.Id;
                        });
                        switch (type) {
                            case 'HolidayDeposit':
                                return hotelSelected[0].HolidayDeposit;
                            case 'AcomType':
                                return hotelSelected[0].AcomType;
                            case 'Location':
                                return hotelSelected[0].Location;
                            case 'Address':
                                return hotelSelected[0].Address;
                        }
                    }
                };

                cm.getFlightInfo = function() {
                    if (cm.flight) {
                        return flightSearch.getFlightInfo(
                            cm.flight.Details.Itinerary ? cm.flight.Details.Itinerary : cm.flight);
                    }
                };

                cm.getBaggageAllowanceTotalKg = function() {
                    return flightSearch.getBaggageAllowanceTotalKg(
                        cm.flight.Details.Itinerary ? cm.flight.Details.Itinerary : cm.flight);
                };

                cm.getBaggagePieces = function() {
                    return flightSearch.getBaggagePieces(
                        cm.flight.Details.Itinerary ? cm.flight.Details.Itinerary : cm.flight);
                };

                cm.getBaggageAllowanceKgPerBag = function() {
                    return flightSearch.getBaggageAllowanceKgPerBag(
                        cm.flight.Details.Itinerary ? cm.flight.Details.Itinerary : cm.flight);
                };

                cm.showFlightDetails = function() {
                    return flightSearch.showFlightDetailsModal(cm.isHotelFirstJourney);
                };

                cm.viewRoom = function() {
                    const elementPosition = document.getElementById('roomsPanel').offsetTop;
                    window.scrollTo({
                    top: elementPosition - 120,
                    behavior: 'smooth'
                    });
                };

                cm.getRoomOccupancyDetails = function() {
                    let occ = occupancyService.getRoomOccupancyString();
                    return occ.slice(occ.indexOf('(') + 1, occ.indexOf(')'));
                };

                cm.facilitiesIcon = function(code) {
                    return cm.facilitiesIcons[code];
                };

                cm.firstRoomSMtext = function() {
                    let skywardsText = document.querySelectorAll('.room .skywards-info');
                    if (skywardsText.length && skywardsText[0].innerText) {
                        let text = skywardsText[0].innerText;
                        let re = new RegExp('([0-9])');

                        if (text.match(re)) {
                            TRPCONFIG.Domain.SkywardsMilesToDisplay = skywardsText[0].innerText;
                        } else {
                            TRPCONFIG.Domain.SkywardsMilesToDisplay = '';
                        }
                    } else {
                        return '';
                    }
                    return TRPCONFIG.Domain.SkywardsMilesToDisplay;
                };
            });
        });
    }

    $scope.$on('$destroy', function() {
        broker.unsubscribe('HotelAvailability');
    });

}
})();
